export default __webpack_public_path__ + "static/social-banner-ac52d103d3153ad3fa09864107054c2a.png";